<template>

  <div class=" border-top mt-4 pt-4">
    <div class="panel-list-wrapper">

      <div class="form-group row mb-0">
        <h2 class="col-4">Code</h2>
        <h2 class="col-6">Panel Name</h2>
        <h2 class="col-2">Hide Panel</h2>
      </div>
      <div class="mt-2">
        <p>Hidden panels are only hidden to a judge and must be unchecked to show them to judges. </p>
      </div>
      <draggable class="drag-episode-titles" v-model="panels_list" @start="drag=true" @end="drag=false">
        <div class="form-group row mb-0" v-for="(panel, index) in panels_list">
          <div class="col-4">
            <div class="d-inline-block align-middle move pl-3 pr-2"><i class="fa fa-arrows-v"></i></div>
            <div class="d-inline-block">
              <input v-model="panel.id" class="form-control mr-4 d-inline-block" type="text">
            </div>
          </div>
          <div class="col-6">
            <input v-model="panel.text" class="form-control" type="text">
          </div>
          <div class="col-1">
            <div class="d-inline-block align-middle">
              <input type="checkbox" :id="'checkbox' + index" class="form-control checkbox d-none" v-model="panel.hide_panel" />
              <label :for="'checkbox' + index" class="checkbox-label">
                <checkbox_checked v-if="panel.hide_panel"></checkbox_checked>
                <checkbox_empty v-else></checkbox_empty>
              </label>
            </div>
          </div>
          <div class="col-1">
            <div class="d-inline-block align-middle" @click.prevent="activateDeletePanelPopup(panel, index)"><trash class=" delete-panel svg-18"></trash></div>
          </div>
        </div>
      </draggable>

      <div class="d-flex align-items-center justify-content-between pt-5">
        <button class="btn btn-black-icon-hover btn-bigger-font" @click.prevent="addNewPanel"><plus_circle class="white-svg svg-24 w-black-hover"></plus_circle> Add New Panel</button>
        <button class="btn btn-primary btn-bigger-font" @click.prevent="savePanelsList">Save Panels List</button>
      </div>

    </div>

    <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
      <h3 slot="header">Remove Panel</h3>
      <div class="content" slot="body">
        <div v-if="PanelsModalDelete.text">Are you sure you want to remove {{PanelsModalDelete.id}} - {{PanelsModalDelete.text}} from the panels list? </div>
        <div v-else>Are you sure you want to remove this panel?</div>
      </div>
      <div class="form-group-submit clearfix" slot="footer">
        <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmDelete = false">Cancel</button>
        <button class="pull-right" @click.prevent="deletePanel(activePanelsIndex)">Yes, Remove</button>
      </div>
    </modal>
  </div>

</template>

<script>
import modal from "./Modal";
import plus_circle from "./icons/plus_circle.vue";
import save from "./icons/save.vue";
import trash from "./icons/trash.vue";
import close from "./icons/close.vue";
import Checkbox_checked from "./icons/checkbox_checked.vue";
import Checkbox_empty from "./icons/checkbox_empty.vue";

export default {
  components: {Checkbox_empty, Checkbox_checked, modal, plus_circle, save, trash, close},
  props: ['panels'],
  data() {
    return {
      panels_list: this.panels,
      modalTriggerConfirmDelete: false,
      PanelsModalDelete: '',
      activePanelsIndex: 0,
    }
  },
  methods: {
    addNewPanel: function() {
      let app = this;
      app.panels_list.push({
        text: ''
      })
    },
    activateDeletePanelPopup(panel, index) {
      let app = this;
      app.modalTriggerConfirmDelete = true;
      app.PanelsModalDelete = panel;
      app.activePanelsIndex = index;
    },
    deletePanel: function(panelId) {
      let app = this;
      if (panelId) {
        app.panels.splice(app.activePanelsIndex, 1);
        app.modalTriggerConfirmDelete = false;
      }
    },
    savePanelsList: function() {
      console.log('value' )
      let app = this;
      let actionUrl = `/settings/panels`;
      window.axios(
          {
            method: 'PUT',
            url: actionUrl,
            data: {
              panels: app.panels_list
            }
          }).then(function(response) {
            location.reload();
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error. There was a problem updating the panels list.';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
  }
}
</script>